import HeaderInput from "./HeaderInput";
import HeaderLogin from "./HeaderLogin";
import HeaderNavItem from "./HeaderNavItem";
import { NavigationHeaderContext } from "./NavigationHeaderContext";
import { Divider, Space } from 'antd';
import cx from 'classnames';
import React, { useContext } from 'react';
var PcHeader = function PcHeader() {
  var NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  var activeMenuTitleOnClick = NavigationHeaderContextProps.activeMenuTitleOnClick,
    onSiteNameClick = NavigationHeaderContextProps.onSiteNameClick,
    siteLogo = NavigationHeaderContextProps.siteLogo,
    siteName = NavigationHeaderContextProps.siteName,
    activeMenuTitle = NavigationHeaderContextProps.activeMenuTitle,
    onLogoClick = NavigationHeaderContextProps.onLogoClick;
  var renderSiteLogo = function renderSiteLogo() {
    if (!siteLogo || typeof siteLogo === 'string') {
      return /*#__PURE__*/React.createElement("img", {
        alt: "logo",
        src: siteLogo || 'https://hwobs.fanruan.com/ui/digit-fe/header/fine_logo_dynamic.gif'
      });
    }
    return siteLogo;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dr-nav"
  }, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement("div", {
    className: cx('dr-nav-logo', onLogoClick && 'dr-nav-click'),
    onClick: function onClick() {
      onLogoClick === null || onLogoClick === void 0 || onLogoClick();
    }
  }, renderSiteLogo()), /*#__PURE__*/React.createElement(Divider, {
    type: "vertical",
    className: "dr-nav-line"
  }), /*#__PURE__*/React.createElement(Space, {
    size: 32
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('dr-nav-title', (onSiteNameClick || activeMenuTitleOnClick) && 'dr-nav-click'),
    onClick: function onClick(e) {
      e.stopPropagation();
      onSiteNameClick === null || onSiteNameClick === void 0 || onSiteNameClick();
      if (!siteName) {
        activeMenuTitleOnClick === null || activeMenuTitleOnClick === void 0 || activeMenuTitleOnClick();
      }
    }
  }, siteName || activeMenuTitle), /*#__PURE__*/React.createElement(HeaderNavItem, null))), /*#__PURE__*/React.createElement(HeaderInput, null), /*#__PURE__*/React.createElement(HeaderLogin, null));
};
export default PcHeader;